import React from "react";
import banner from "../../assets/01_Home/HYUNDAIKONA_17.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div
      className="banner-vehiculos-component"
      style={{ backgroundImage: `url(${banner})` }}
    >
      <div className="mascara-banner-vehiculos-component">Vehículos</div>
    </div>
  );
};

export default BannerComponent;
